﻿'use strict';

/**
 * @ngdoc directive
 * @name ntmApp.directive:recurrenceOnlyNum
 * @description
 * # recurrenceOnlyNum
 */
///////////////////// Directive to make sure the number fields accepts only integers
angular.module('ntmApp').directive('onlyNum', function () {
    return {
        restrict: 'A',
        link: function (scope, elm) {
            elm.on('keydown', function (event) {
                
                if (event.which === 64 || event.which === 16) {
                    // to allow numbers
                    return false;
                } else if (event.which >= 48 && event.which <= 57) {
                    // to allow numbers
                    return true;
                } else if (event.which >= 96 && event.which <= 105) {
                    // to allow numpad number
                    return true;
                } else if ([8, 13, 27, 37, 38, 39, 40, 46].indexOf(event.which) > -1) {
                    // to allow backspace, enter, escape, arrows
                    return true;
                } else {
                    var patt = new RegExp(/^\d+$/);
                    if (!patt.test(event.key)) {
                        event.preventDefault();
                        return;
                    }
                }
            });
        }
    };
});

///////////////////////////////////////////////////////////////////////////////

